import camelize from 'camelize';

export const parseJSON = (str, defaultValue = null) => {
  try {
    return camelize(JSON.parse(str));
  } catch (err) {
    return defaultValue;
  }
};
